import { render } from "./SelectList.vue?vue&type=template&id=37045c01&scoped=true"
import script from "./SelectList.vue?vue&type=script&lang=js"
export * from "./SelectList.vue?vue&type=script&lang=js"

import "./SelectList.vue?vue&type=style&index=0&id=37045c01&scoped=true&lang=css"
import "./SelectList.vue?vue&type=style&index=1&id=37045c01&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37045c01"]])

export default __exports__